import React from 'react'
import View from './view.js'
import { useDataValue } from 'Simple/Data.js'

export default function Logic(props) {
  let isDraggableList = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'feature_flags.is_automation_hub_comms_enabled',
  })

  let actions = useDataValue({
    context: 'automation',
    viewPath: props.viewPath,
    path: 'actions',
  })

  return isDraggableList ? (
    <div {...props} {...props.dragHandleProps}>
      <View {...props} disabled={actions.length === 1 || props.disabled} />
    </div>
  ) : (
    <></>
  )
}
